import * as React from 'react'
import { useDrivers } from '@/modules/shared/context/drivers/DriversContext'
import { TableProvider } from '@/modules/drivers/context/TableContext'

import { EditGroupsFormProvider } from '@/modules/drivers/context/EditGroupsContext'
import AddGroupModal from './AddGroupModal'
import useGroupService from '@/modules/drivers/services/GroupService'
import DriverGroupInfoBox from './managment/DriverGroupInfoBox'
import EditGroupFooter from './edit/EditGroupFooter'
import DriversInGroupTable from './managment/DriversInGroupTable'
import EditGroupHeader from './edit/EditGroupHeader'
import EditNameGroupModal from './EditNameGroupModal'

const EditGroupDetailsModal = ({
  group,
  close,
  companyId,
  isDefaultGroup = false,
}) => {
  const { drivers, refresh} = useDrivers()
  const [isAddGroupModelOpen, setIsAddGroupModelOpen] = React.useState(false)
  const { removeGroups } = useGroupService()
  const [isOpenChangeGroupName, setIsOpenChangeGroupName] =
    React.useState(false)
  return (
    <EditGroupsFormProvider
      companyId={companyId}
      drivers={drivers}
      group={group}
    >
      <div className="tw-fixed tw-inset-0 tw-z-[350] tw-flex tw-items-center tw-justify-center tw-overflow-auto tw-overflow-y-auto tw-bg-content-base tw-bg-opacity-70">
        <div className="tw-flex tw-max-h-[500px] tw-w-full tw-max-w-[1000px] tw-flex-col tw-justify-between tw-rounded-lg tw-bg-white">
          <EditGroupHeader name={group?.name ?? ''} close={close} />
          <TableProvider bulk>
            <div className="tw-flex-1 tw-overflow-auto tw-pt-0">
              <DriversInGroupTable allDrivers={drivers} />
            </div>
            {!isDefaultGroup && <DriverGroupInfoBox />}
            <EditGroupFooter
              setIsOpenChangeGroupName={setIsOpenChangeGroupName}
              close={close}
              isDefaultGroup={isDefaultGroup}
              remove={() =>
                removeGroups({ companyId: companyId, groupIds: [group.id] })
              }
            />
          </TableProvider>
        </div>
      </div>
      {isOpenChangeGroupName && (
        <EditNameGroupModal
          groupId={group.id}
          companyId={companyId}
          currenatGroupName={group.name}
          refreshGroups={refresh}
          close={() => setIsOpenChangeGroupName(false)}
        />
      )}
      {isAddGroupModelOpen && (
        <AddGroupModal
          isEdit
          openGroupMembers={true}
          companyId={companyId}
          refreshGroups={refresh}
          close={() => setIsAddGroupModelOpen(false)}
        />
      )}
    </EditGroupsFormProvider>
  )
}
export default EditGroupDetailsModal
